<template>
  <div
    class="scroll-view"
    :style="maxHeight != null ? `max-height: ${maxHeight}` : ''"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ScrollView',
  props: {
    maxHeight: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.scroll-view {
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
